export class ConfigurationManager {
    public static isModifyRegionOnlyMode: boolean = false;
    public static isPathRegionEnabled: boolean = false;
}
